import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    boxShadow: "none",
    backgroundColor: " rgba(255, 255, 255, 0.4) !important",
    borderBottom: "3px solid rgba(255, 255, 255, 0.5) !important",
  },
  padding: {
    paddingTop: "7px",
    paddingBottom: "7px",
  },
  heading: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: "bold",
    color: "#000",
  },
  contentBg: {
    backgroundColor: " rgba(255, 255, 255, 0.6) !important",
    paddingTop: "30px",
  },
}));

const AppContent = ({ license }) => {
  const classes = useStyles();

  if (license) {
    return (
      <div className="w-full px-6 lg:px-32 pt-1 pb-5">
        <Accordion className={classes.root}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.padding} aria-controls="panel1a-content" id="panel1a-header">
            <Typography className={classes.heading}>LICENSE</Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.contentBg}>
            <div dangerouslySetInnerHTML={{ __html: license }} className="text-xs break-all" />
          </AccordionDetails>
        </Accordion>

        {/*  원래 라이센스
          <p className="text-xs font-bold text-333 font-gmarket-medium break-all sm:pr-5">
            LICENSE
          </p>
          <div
            dangerouslySetInnerHTML={{ __html: license }}
            className="text-xs break-all"
          /> */}
      </div>
    );
  } else {
    return "";
  }
};
export default AppContent;
